import styled from "styled-components";
import {JBOptinReminderCheckboxDefaultBox} from "./jb-optin-reminder-checkbox.default.box";

export const JBOptinReminderCheckboxMRGreenBox = styled(JBOptinReminderCheckboxDefaultBox)`
    background-color: ${props => props.theme.colors.brandPrimaryContrast};
    border-color: ${props => props.theme.colors.text};
`